import { useIsSitesEnabled } from "@/react/components/SettingsApp/Site/Pages/useIsSitesEnabled";
import { BlocksViewer } from "@circle-react/components/Spaces/CourseSpace/Lockscreen/BlocksViewer/BlocksViewer";
import { useGetLockscreenBlocks } from "@circle-react/components/Spaces/CourseSpace/Lockscreen/hooks";
import { useSpaceResource } from "@circle-react/contexts";
import type { Space } from "@circle-react/types";
import { Loader } from "@circle-react-uikit/Loader";
import { SitePageLockscreen } from "./SitePageLockscreen";

export interface SpaceLockScreenProps {
  space: Space;
}

export const SpaceLockScreen = ({ space }: SpaceLockScreenProps) => {
  const isSitesEnabled = useIsSitesEnabled();

  // Always fetch complete space resource to ensure we have all lockscreen data
  // SpaceResource is the show action, it includes the legacy (trix) locked_page_description and Course data
  const { data: spaceResource, isLoading } = useSpaceResource({
    spaceId: space?.id,
  });

  const isSitePageLockscreensEnabled =
    isSitesEnabled && Boolean(space.lockscreen_site_page_id);

  const blocks = useGetLockscreenBlocks(spaceResource);

  if (isLoading || !spaceResource) {
    return <Loader center />;
  }

  return isSitePageLockscreensEnabled ? (
    <SitePageLockscreen space={space} />
  ) : (
    <BlocksViewer blocks={blocks} />
  );
};
